var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPremium = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14.0002C0 21.7199 6.28035 28.0002 14 28.0002C21.7197 28.0002 28 21.7199 28 14.0002C28 6.28059 21.7197 0.000244141 14 0.000244141C6.28035 0.000244141 0 6.28059 0 14.0002Z",
    fill: "url(#linear-645768)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7461 7L18.3711 11.6667H9.62109L12.2461 7H15.7461Z",
    fill: "#191B25"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9961 22.75L9.62109 12.8333H18.3711L13.9961 22.75Z",
    fill: "#191B25"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.49609 12.8333L13.9961 22.75L7.87109 12.8333H3.49609Z",
    fill: "#191B25"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99609 7H12.2461L7.87109 11.6667H3.49609L6.99609 7Z",
    fill: "#191B25"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1211 11.6667H24.4961L20.9961 7H15.7461L20.1211 11.6667Z",
    fill: "#191B25"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9961 22.75L20.1211 12.8333H24.4961L13.9961 22.75Z",
    fill: "#191B25"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-645768",
    x1: 14,
    y1: 28.0002,
    x2: 14,
    y2: 0.000244141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#987542"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1C08C"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPremium);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/premium.304eaca2.svg";